import { RolesData, SearchBranchWithCompanyId, SearchCompanies } from "./AddUserEntrySection/AddUserEntrySection";

export let data = [
  {
    id: Math.random() * 10,
    name: "User_Name",
    fields: [
      {
        id: Math.random() * 10,
        name: "Full_Name",
        label: "Full Name",
        autoFocus: true,
      },
      {
        id: Math.random() * 10,
        name: "Default_Company",
        label: "Default Company ",
        masterName: "Company",
        type: "InputDropForQuery",
        dropdowndata: SearchCompanies,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "User_Details1",
    fields: [
      {
        id: Math.random() * 10,
        name: "Default_Branch",
        label: "Default Branch",
        type: "InputDropForQuery",
        masterName: "Branch",

        Reference_field: ["Default_Company", "Company_ID"],
      },
      {
        id: Math.random() * 10,
        name: "Department",
        label: "Department",
        type: "text",
        min: 0,
        max: Infinity,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "User_Details2",
    fields: [
      {
        id: Math.random() * 10,
        name: "Email",
        label: "Email",
        type: "text",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Mobile",
        label: "Mobile",
        type: "number",
        min: 10,
        max: 10,
      },
    ],
  },

  {
    id: Math.random() * 10,
    name: "User_Details3",
    fields: [
      {
        id: Math.random() * 10,
        name: "UserName",
        label: "User Name",
        type: "text",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Role",
        Store_ID: "id",
        masterName: "Role",
        label: "User Role ",
        masterSearch: true,
        type: "InputDropForQuery",
        dropdowndata: RolesData,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "User_Details4",
    fields: [
      {
        id: Math.random() * 10,
        name: "Password",
        label: "Password",
        type: "password",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Re_Type_Password",
        label: "Re-Type Password",
        type: "password",
        min: 0,
        max: Infinity,
      },
    ],
  },
  // {
  //   id: Math.random() * 10,
  //   name: "User_Details4",
  //   fields: [
  //     {
  //       id: Math.random() * 10,
  //       name: "Password",
  //       label: "Password",
  //       type: "password",
  //       min: 0,
  //       max: Infinity,
  //     },
  //     {
  //       id: Math.random() * 10,
  //       name: "Re_Type_Password",
  //       label: "Re-Type Password",
  //       type: "password",
  //       min: 0,
  //       max: Infinity,
  //     },
  //   ],
  // },
  {
    id: Math.random() * 10,
    name: "User_Rights_details5",
    fields: [
      {
        id: Math.random() * 10,
        name: "LR_Center",
        label: "LR Center",
        type: "InputDropForQuery",
        masterName: "LR_Center_Data",
        clearField: "Branch_Code",
        min: 2,
        max: Infinity,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "User_Rights_details2",
    fields: [
      {
        id: Math.random() * 10,
        name: "Merge_Balance",
        label: "Merge Balance",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "View_Only_Current_Year",
        label: "View Only Current Year",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
    ],
  },
];
